import { irSubScenesSlice } from "./irSubScenesSlice";
import * as defaultActions from "../../../../../redux/_common";
import * as fields from "../../pages/IRData/tabs/irSubScenes/edit/constants";

const { actions } = irSubScenesSlice;

export const setValidationErrors = actions.setValidationErrors;
const moduleUrl = '/api/imagerecognition/subscenetypes'

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

//Reset state
export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
